/**
 * region for libraries*/
import React, { Component } from 'react';
import { Button, ModalBody, ModalFooter } from 'reactstrap';

/**
 * region for components*/
import TabPanel from '../../TabPanel'

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';
import list from '../../../../helpers/list';
import validation from '../../../../helpers/validation';
import {commonFunction} from '../../../../helpers/commonFunction';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'


import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Button as ButtonMui }  from '@material-ui/core';
import { Fragment } from 'react';

const CustomeTab = withStyles(theme => ({
    root: {
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(16),
        '&:hover': {
            color: '#cfcfcf',
            opacity: 1,
        },
        '&$selected': {
            color: '#000',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#000',
        },
    },
    selected: {},
}))(props => <Tab {...props} />);

const CustomeButton = withStyles({
    root: {
        textTransform: 'none',
        color: '#6AA4E6',
        border: '1px solid',
        backgroundColor: '#fff',
        borderColor: '#6AA4E6',
        '&:hover': {
            backgroundColor: '#fcfcfc',
            borderColor: '#6AA4E6',
            boxShadow: 'none',
        },
    },
})(ButtonMui);

export class Step1 extends Component {
    static displayName = Step1.name;

    constructor(props) {
        super(props);

        this.state = {
            mode: Constants.MODE_LOADED,
            keywordText: props.keywordText,
            searchCategory: '', 
            isCategorySearched: false,
            categoryListByKeywordText: [],
            categoryListByName: [],
            categoryListAdded: [],
            valueTab: 0,
            nameNewCategory : '',
            listCategories: [],
            isAddNewCategorie: true,
            textBadNameCategory: '',
            textErrorNoCheckCategory: '',
            saveInModalView: true,
        };

    }

    load() {
        const self = this;

        let requestData = {
            keywordText: this.state.keywordText
        };
        self.setState({ saveInModalView : this.props.saveInModalView });
        if (this.state.keywordText !== "") {

            ajax.get(Constants.ROUTE_API_CATEGORIES,
                {
                    requestData: requestData,
                    success: function (response) {
                        self.setState({
                            mode: Constants.MODE_LOADING,
                            categoryListByKeywordText: response.data,
                            searchCategory :self.state.keywordText
                        }, () => self.loadSuperCategories(), self.SearchFilter(self.state.keywordText));
                    }
                });
        
        } 
        else {
            if(self.props.keywordsSelect.length === 1) {

                const getKeywordInLocalStorage = JSON.parse(window.localStorage.getItem("keywords"))
                var keywordText = getKeywordInLocalStorage[0].KEYWORD;
                self.setState({
                    searchCategory : keywordText
                }, function(){
                    self.SearchFilter(keywordText);
                } );        

            }
            self.loadSuperCategories();
        }
    }

    getTitleCategory(description, sites)
    {
        let componentSites = sites.map((item) => ( item !== "")? <span key={item} className={`badge badge-alt badge-${commonFunction.getSiteAcronym(parseInt(item))}`}>{commonFunction.getSiteAcronym(parseInt(item))}</span> : "");
        let component =  <Fragment> <span>{description} </span> {componentSites} </Fragment>;
        return component;
    }

    loadSuperCategories() {
        const self = this;
        ajax.get(Constants.ROUTE_API_CATEGORIES_SUPER_CATEGORIES,
            {
                requestData: {},
                success: function (subResponse) {
                    const { data } = subResponse
                    const listCategories = data.map(item => {

                        return {
                            label: self.getTitleCategory(item.DESCRIPTION, item.SITES.split(",") ),
                            value: item.IDCATEGORY,
                            isCheck: false,
                        }
                    })

                    self.setState({
                        listCategories: listCategories
                    });
                }
            })
    }

    componentDidMount() {
        this.load();
    }

    handleChange(event) {
        this.setState({
            searchCategory: event.target.value
        });
    }

    handleOnChangeSearchFilter(event) {
        event.preventDefault();
        const self = this;
        self.SearchFilter(self.state.searchCategory);
    }

    SearchFilter(searchCategory) {

        const self = this;
        if (!typing.isEmpty(searchCategory)) {
            self.setState(
                {
                    mode: Constants.MODE_LOADING
                },
                function () {
                    let requestData = {
                        categoryName: searchCategory
                    };

                    ajax.get(Constants.ROUTE_API_CATEGORIES,
                        {
                            requestData: requestData,
                            success: function (response) {
                                self.setState({
                                    mode: Constants.MODE_LOADED,
                                    categoryListByName: response.data,
                                    isCategorySearched: true
                                });
                            }
                        })
                });
        }
    }

    onKeyPress = (e) => {
        if (e.which === 13) {
            this.handleOnChangeSearchFilter(e);
        }
    }

    handleNext() {
        if (this.props.handleNext) {
            this.props.handleNext();
        }
    }

    handleOnClose() {
        if (this.props.onClose) {
            this.props.onClose();
        } 
    }

    handleSaveKeyword(categories, event) {

        event.preventDefault();

        const idsCategories = categories.map(x => x.IDCATEGORY)

        if (this.state.keywordText !== "") {
            this.handleSaveSingleKeyword(idsCategories)
        } else {
            this.handleSaveMultipleKeywords(idsCategories)
        }
    }

    handleSaveSingleKeyword(categories) {

        const self = this;
        let requestData = {
            Name: this.state.keywordText,
            IdList: categories
        };

        if(this.state.saveInModalView) {
            ajax.post(Constants.ROUTE_API_KEYWORDS,
                {
                    requestData: requestData,
                    success: function (response) {
                        self.setState({
                            mode: Constants.MODE_LOADED
                        });
                    }
                });          
            self.props.onRefreshRelateKeywords();     
        }
        else{
            self.props.onRefreshRelateKeywords();   
            self.props.returnObjects(requestData);      
        }
    }

    handleSaveMultipleKeywords(categories) {

        const self = this;
        let requestData = {
            IdList: this.props.keywordsSelect,
            IdListSecondary: categories
        };

        ajax.post(Constants.ROUTE_API_CONTENT_KEYWORDS_CATEGORIES_LIST,
            {
                requestData: requestData,
                success: function (response) {
                    self.props.onRefreshRelateKeywords()
                }
            });
    }

    handleAddCategory(category, event) {
        event.preventDefault();
        const self = this;

        let categoryList = self.state.categoryListAdded;

        let categoryListByKeywordText = typing.clone(self.state.categoryListByKeywordText); 
        let categoryListByName = typing.clone(self.state.categoryListByName);

        let indexListByKeywordText = list.getIndex(categoryListByKeywordText, x => x.IDCATEGORY === category.IDCATEGORY); 
        let indexListByListByName = list.getIndex(categoryListByName, x => x.IDCATEGORY === category.IDCATEGORY);

        if (indexListByKeywordText >= 0) {
            categoryListByKeywordText.splice(indexListByKeywordText, 1);
        }

        if (indexListByListByName >= 0) {
            categoryListByName.splice(indexListByListByName, 1);
        }

        categoryList.push(category);

        self.setState({
            mode: Constants.MODE_LOADED,
            categoryListByKeywordText: categoryListByKeywordText,
            categoryListByName: categoryListByName,
            categoryListAdded: categoryList
        });

    }

    handleRemoveCategory(category, event) {
        event.preventDefault();
        const self = this;

        let categoryListByKeywordText = self.state.categoryListByKeywordText;
        let categoryListByName = self.state.categoryListByName;
        let categoryList = self.state.categoryListAdded;

        let index = list.getIndex(categoryList, list => list.IDCATEGORY === category.IDCATEGORY);

        if (index >= 0) {
            categoryList.splice(index, 1);
        }

        categoryListByKeywordText.push(category);
        categoryListByName.push(category);

        self.setState({
            mode: Constants.MODE_LOADED,
            categoryListAdded: categoryList,
            categoryListByName: categoryListByName,
            categoryListByKeywordText: categoryListByKeywordText
        });
    }

    /**New Code**/

    handleChangeTabs(event, value) {
        this.setState({ valueTab: value })
    };

    handleChangeNewNameCategorie(event) {
        let value = event.target.value
        this.setState({ nameNewCategory: value })
    }

    handleChangeClickCheckBoxCate(cat) {
        const { listCategories } = this.state
        const { value, isCheck } = cat
        const newListCate = listCategories.map(itemCat => {
            if (itemCat.value === value) {
                itemCat.isCheck = !isCheck
            }
            return itemCat
        })

        this.setState({ listCategories: newListCate})
    }

    handleCreateNewCategory() {

        const self = this;

        const { nameNewCategory, listCategories, categoryListAdded } = self.state
        const filterListCategories = listCategories.filter(x => x.isCheck === true)
        const checkRepeateNewlistCategories = categoryListAdded.filter(x => x.DESCRIPTION === nameNewCategory.trim())

        let nameNewCategoryTemp=nameNewCategory.trim();
        validation.isCheckExistCategory(nameNewCategoryTemp).then(response => {

            const { valid, text } = response

            if (valid &&
                filterListCategories.length > 0 &&
                checkRepeateNewlistCategories.length === 0) {               

                let subRequestData = self.formatDataBeforeSaveNewCategorie()
                ajax.post(Constants.ROUTE_API_CATEGORIES_CREATE_CATEGORY,
                {
                    requestData: subRequestData,
                    success: function (subResponse) {

                        const { success, data } = subResponse

                        if (success === true && data.length > 0) {

                            categoryListAdded.push({ IDCATEGORY: data[0].IDCATEGORY, DESCRIPTION: nameNewCategoryTemp, KEYWORD_NUMBER: 0, SITES: data[0].SITES  })

                            self.setState({
                                isAddNewCategorie: false,
                                textBadNameCategory: '',
                                textErrorNoCheckCategory: '',
                                categoryListAdded: categoryListAdded,
                                nameNewCategory:nameNewCategoryTemp
                            });
                        }
                    }
                })

            } else {

                let setTextErrorNoCheckCategory = ''

                if (filterListCategories.length === 0) {
                    setTextErrorNoCheckCategory = 'You must select at least one parent category'
                } else if (checkRepeateNewlistCategories.length > 0) {
                    setTextErrorNoCheckCategory = `the ${nameNewCategory} category is repeated`
                }

                this.setState({
                    textBadNameCategory: text,
                    textErrorNoCheckCategory: setTextErrorNoCheckCategory,
                    nameNewCategory:nameNewCategoryTemp
                })
            }
        })       
    }

    handleCreateOtherNewCategorie() {
        const { listCategories } = this.state;
        const resetListCategories = listCategories.map(item => {
            item.isCheck = false
            return item
        })

        this.setState(
            {
                nameNewCategory: '',
                listCategories: resetListCategories,
                isAddNewCategorie: true
            })
    }

    formatDataBeforeSaveNewCategorie() {

        const { nameNewCategory, listCategories } = this.state

        const selectCate = listCategories.filter(x => x.isCheck === true).map(subItem => {
            return subItem.value
        })        

        let nameNewCategoryTemp= nameNewCategory.trim()
        let objNewCategorie = {
            Description: nameNewCategoryTemp,
            IdParent: selectCate[0],
            DescriptionSimple: nameNewCategoryTemp,
            RelateKeyword: ``,
            RelateChannel: selectCate.join()
        }

        return objNewCategorie
    }

    /**End New Code**/

    render() {

        const self = this;
        const { valueTab, nameNewCategory, listCategories, isAddNewCategorie,
            textBadNameCategory, textErrorNoCheckCategory } = self.state


        let categoriesFilteredListByKeywordText;

        categoriesFilteredListByKeywordText = this.state.categoryListByKeywordText.map(function (category) {
            return (
                <li key={category.IDCATEGORY}>
                    <button type="button" className="btn btn-sm btn-outline-warning" onClick={self.handleAddCategory.bind(self, category)}>
                        <i className="fas fa-plus"></i>
                    </button> {category.DESCRIPTION} <span>({category.KEYWORD_NUMBER})</span>  &nbsp;
                    { category.SITES != null && category.SITES.split(",").map((item) => ( item !== "")? <span key={item} className={`badge badge-alt badge-${commonFunction.getSiteAcronym(parseInt(item))}`}>{commonFunction.getSiteAcronym(parseInt(item))}</span> : "") }
                </li>
            );
        });

        let categoriesFilteredListByName;
        categoriesFilteredListByName = this.state.categoryListByName.map(function (category) {
            return (
                <li key={category.IDCATEGORY}>
                    <button type="button" className="btn btn-sm btn-outline-warning btn-add-category" onClick={self.handleAddCategory.bind(self, category)}>
                        <i className="fas fa-plus"></i>
                    </button> {category.DESCRIPTION} <span>({category.KEYWORD_NUMBER})</span> &nbsp;
                    { 
                        category.SITES != null && category.SITES.split(",").map((item) => ( item !== "")? <span key={item} className={`badge badge-alt badge-${commonFunction.getSiteAcronym(parseInt(item))}`}>{commonFunction.getSiteAcronym(parseInt(item))}</span> : "")
                    }
                </li>
            );
        });

        let categoryListAdded = this.state.categoryListAdded.map(function (category) {
            return (
                <li key={category.IDCATEGORY}>
                    <button type="button" className="btn btn-sm btn-outline-secondary btn-add-category" onClick={self.handleRemoveCategory.bind(self, category) }>
                        <i className="fas fa-times"></i>
                    </button> {category.DESCRIPTION} <span>({category.KEYWORD_NUMBER})</span> &nbsp;
                    { category.SITES != null && category.SITES.split(",").map((item) => ( item !== "")? <span key={item} className={`badge badge-alt badge-${commonFunction.getSiteAcronym(parseInt(item))}`}>{commonFunction.getSiteAcronym(parseInt(item))}</span> : "") }
                </li>
            );
        });


        let categoriesFilteredList;
        if (this.state.categoryListByName.length > 0 && this.state.isCategorySearched) {
            categoriesFilteredList = categoriesFilteredListByName;
        } else {
            categoriesFilteredList = categoriesFilteredListByKeywordText;
        }
    
        let acceptButtonClass = (this.props.acceptButton && this.props.acceptButton.className) || 'btn';
        let acceptButtonText = (this.props.acceptButton && this.props.acceptButton.text) || 'SAVE';
        
        if(!this.state.saveInModalView) {
            acceptButtonText = (this.props.acceptButton && this.props.acceptButton.text) || 'ACCEPT';
        }
        let searchButton;
        if (this.state.mode === Constants.MODE_LOADING) 
        {
            searchButton = <button type="button" className="btn btn-secondary"><i className="fas fa-spinner fa-spin"></i></button>;
        }else
        {
            searchButton = <button type="button" className="btn btn-secondary" onClick={this.handleOnChangeSearchFilter.bind(this)}><i className="fas fa-search"></i></button>;
        }

        return (
            <div>
                <ModalBody className="font-size-md">
                    <p className="text-center font-size-lg">
                        {this.state.keywordText ? this.state.keywordText : `Please select the categories you want to relate these ${this.props.keywordsSelect.length}`}
                    </p>
                    <Tabs                       
                        indicatorColor="primary"
                        textColor="primary"
                        value={valueTab}
                        onChange={this.handleChangeTabs.bind(this)} aria-label="simple tabs">
                        <CustomeTab label="Choose Categories"/>
                        <CustomeTab label="Create Category" />
                    </Tabs>

                    <div className="row">

                     {valueTab === 0 && (
                            <TabPanel>
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-12 text-left sepataion-small-vertical-margin">
                                            <div className="input-group" >
                                                <input type="text" className="form-control" placeholder="Search" value={this.state.searchCategory} onChange={this.handleChange.bind(this)} onKeyPress={this.onKeyPress} />
                                                <span className="input-group-prepend">
                                                    {searchButton}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="scroll-container scroll-container-lg chage-height-scroll-container-lg">
                                                <ul className="list-unstyled list-services">
                                                    {categoriesFilteredList}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        )}

                        {valueTab === 1 && (
                            <TabPanel>
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-12 text-left sepataion-small-vertical-margin" style={{ visibility: isAddNewCategorie ? 'visible' : 'hidden' }}>
                                            <div className="input-group" >
                                                <input type="text"
                                                    className="form-control"
                                                    placeholder="Enter the new subcategory name"
                                                    value={nameNewCategory}
                                                    onChange={this.handleChangeNewNameCategorie.bind(this)} />
                                            </div>
                                            {
                                                textBadNameCategory !== '' && (
                                                    <p className="text-red-600 m-0 text-sm text-alert-no-categoty-valid">{textBadNameCategory}</p>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            {
                                                isAddNewCategorie ? (
                                                    <div>
                                                        <div className="scroll-container scroll-container-lg chage-height-scroll-container-lg-cat">
                                                            <FormControl component="fieldset">
                                                                <FormGroup>
                                                                    {
                                                                        listCategories.map(cat => {
                                                                            return (
                                                                                <FormControlLabel key={cat.value} className="m-0"
                                                                                    control={
                                                                                        <Checkbox
                                                                                            color="primary"
                                                                                            checked={cat.isCheck}
                                                                                            value={cat.value}
                                                                                            onChange={this.handleChangeClickCheckBoxCate.bind(this, cat)}
                                                                                        />
                                                                                    }
                                                                                    label={cat.label}
                                                                                />
                                                                            )
                                                                        })
                                                                    }
                                                                </FormGroup>
                                                            </FormControl>
                                                        </div>
                                                        <div className="float-right">
                                                            <CustomeButton variant="outlined" onClick={() => this.handleCreateNewCategory()} color="primary">
                                                                Create
                                                        </CustomeButton>
                                                        </div>
                                                        {
                                                            textErrorNoCheckCategory !== '' && (
                                                                <p className="text-red-600 m-0 text-sm text-alert-no-check">{textErrorNoCheckCategory}</p>
                                                            )
                                                        }
                                                    </div>
                                                ) : (
                                                        <div className="chage-height-scroll-container-lg-cat">
                                                            <div className="add-center-message">
                                                                <div className="img-success" />
                                                                <p className="text-gray-700"> Category Created </p>
                                                                <CustomeButton variant="outlined" onClick={() => this.handleCreateOtherNewCategorie()} color="primary">Create more</CustomeButton>
                                                            </div>
                                                        </div>
                                                    )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        )}

                        <div className="col-6 margin-top-cont">
                            <div className="scroll-container scroll-container-lg chage-height-scroll-container-lg">
                                <ul className="list-unstyled list-services">
                                    {categoryListAdded}
                                </ul>
                            </div>
                        </div>
                    </div>
                
                </ModalBody>
                <ModalFooter>
                    <Button color="" onClick={this.handleOnClose.bind(this)}>CANCEL</Button>
                    <Button color="primary" className={acceptButtonClass} onClick={this.handleSaveKeyword.bind(this, this.state.categoryListAdded)}>{acceptButtonText}</Button>
                </ModalFooter>               
            </div>
        );
    }
}
